import { sortPartialDate } from 'neuro-utils';
import { getOngoingDrivingBan, isOngoingTimespan } from '../utils';

import type { getBackgroundTimeseries } from 'neuro-calculation-commons';

export interface IDrivingStatus {
  hasLicense: boolean | 'unknown';
  licenseGroup: string[];
  professionalDriving: string | null;
  r1: { active: boolean; startDate?: PartialDate | null };
  r2: { active: boolean; startDate?: PartialDate | null };
  noProReqs: Array<{ startDate: PartialDate; endDate?: PartialDate }>;
}

export const resolveWeightOrBmi = (series: ReturnType<typeof getBackgroundTimeseries>['series']) => {
  const w = series['weight']?.[0];
  const b = series['bmi']?.[0];

  if (!w && !b) return [];
  if (w && !b) return ['weight'];
  if (!w && b) return ['bmi'];

  // Safe comparison
  if (w && b) {
    return sortPartialDate(w.date, b.date) <= 0 ? ['weight'] : ['bmi'];
  }
  return [];
};

export const analyzeDrivingStatus = (doc: IDocumentWithTypeV2<'background'> | undefined): IDrivingStatus => {
  const status: IDrivingStatus = {
    hasLicense: 'unknown',
    licenseGroup: [],
    professionalDriving: null,
    r1: { active: false },
    r2: { active: false },
    noProReqs: [],
  };

  if (!doc) return status;

  status.hasLicense = doc.driversLicense === 'yes' ? true : doc.driversLicense === 'no' ? false : 'unknown';
  status.licenseGroup = doc.driversLicenseGroup ?? [];
  status.professionalDriving = doc.professionalDriving ?? null;

  if (status.licenseGroup.includes('R1')) {
    const ban = Array.isArray(doc.drivingBanR1s) ? getOngoingDrivingBan(doc.drivingBanR1s as IDrivingBan[]) : undefined;
    status.r1 = { active: !!ban, startDate: ban?.startDate };
  }
  if (status.licenseGroup.includes('R2')) {
    const ban = Array.isArray(doc.drivingBanR2s) ? getOngoingDrivingBan(doc.drivingBanR2s as IDrivingBan[]) : undefined;
    status.r2 = { active: !!ban, startDate: ban?.startDate };
  }

  if (doc.noProDrivingRequirements) {
    status.noProReqs = doc.noProDrivingRequirements.filter(d =>
      isOngoingTimespan(d.startDate, d.endDate),
    ) as IDrivingStatus['noProReqs'];
  }

  return status;
};
